<template>
  <Modal @closeModal="handleCerrar" :showMovilHeader="true" :fit="true" :showHeader="false" :linea="false" >
  <div class="body-container">
    <img src="@/assets/imgs/icons/mono-editar.svg"/>
    <p class="title">¿Está seguro que desea cambiar el estatus de la cita a {{getStatus}}?</p>
    <p class="cliente-label"> {{ status.cliente }}</p>
    <p class="msg">*Los estatus no pueden regresar a su estado anterior.</p>
    <div class="btn-container">
        <button class="btn-cancelar" @click="handleCerrar" >Cancelar</button>
        <button class="btn-aceptar" @click="editarStatus">Aceptar</button>
    </div>
  </div>
  </Modal>
</template>

<script>
import Modal from '../Modales/Modal.vue';
export default {
components:{
    Modal
},
emits:["cerrar"],
props:{
    status:{
        type:Object,
        required:true
    }
},
methods:{
    handleCerrar(){
        this.$emit("cerrar")
    },
    editarStatus(){
        this.$emit("editar",{status:this.status?.status,id:this.status.id})
    }
},
computed:{
    getStatus() {
      switch (this.status?.status) {
        case 0:
          return "cancelar";
        case 1:
          return "pendiente";
        case 2:
          return "no asistio";
        case 3:
          return "asistio";
        default:
          return "pendiente";
      }
    },
}
}
</script>

<style scoped>

.body-container{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  
    padding: 20px 40px;
}
img{
    widows: 80px;
    height: 95px;
}
.title{
width: 322px;
text-align: center;
font: normal normal bold 20px/27px Open Sans;
letter-spacing: 0px;
color: #0A4F9C;
}
.cliente-label{
text-align: center;
font: normal normal bold 20px/27px Open Sans;
letter-spacing: 0px;
color: #C4C4C4;
}
.msg{
text-align: center;
font: normal normal normal 14px/19px Open Sans;
letter-spacing: 0px;
color: #C4C4C4;
}
.btn-container{
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.btn-cancelar{
    width: 70px;
height: 22px;
text-align: left;
font: normal normal bold 16px/22px Open Sans;
letter-spacing: 0px;
color: #4CAF50;
}
.btn-aceptar{
    width: 172px;
height: 40px;
background: #4CAF50 0% 0% no-repeat padding-box;
border-radius: 4px;
color: #fff;
}

@media screen and (max-width: 767px) {
.title{
    font: normal normal bold 14px/19px Open Sans;
}
.body-container{
    padding: 20px;
    height: 100vh;
}
}

</style>